export default __webpack_public_path__ + "static/IN-8015_8mm_lense_night_hardwareWDR-c5f9bed6ab4fb858a8d1d3eb820bab7c.webp";